import { Controller } from "@hotwired/stimulus";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--skill-sheet-job-histories"
export default class extends Controller {
  static targets = ["list", "hiddenId"];
  static values = {
    skillSheetId: Number,
  };

  connect() {
    TurboStreamHeaders(this);
  }

  new(e) {
    e.preventDefault();

    // 作成するレコードのidが被らないよう、
    const currentNumber = this.hiddenIdTargets.length;

    const params = {
      "resume_skill_sheet[id]": this.skillSheetIdValue,
      job_history_index: currentNumber,
    };
    const query = new URLSearchParams(params).toString();

    fetch(`/skill_sheet_job_history/new?${query}`, {
      method: "GET",
      headers: {
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
